<template>
  <div class="container flex flex-col items-center justify-center min-h-[50vh]">
    <h1 class="max-w-[35rem] text-center text-xl font-bold leading-[1.875rem] mb-4">
      The content you are trying to access no longer exists, or you do not have access to it.
    </h1>
    <GbButton
      gbTheme="bluePrimary"
      @click="returnToLibrary"
    >
      <span class="material-icons-outlined mr-1" aria-hidden="true">
        arrow_back
      </span>
      Return to Library
    </GbButton>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import GbButton from '@/components/GbButton.vue'

const router = useRouter()

const returnToLibrary = () => {
  router.push({ name: 'Library' })
}
</script>
